module.exports = __webpack_public_path__ + "img/nt52-02a-80-1.prt.c5330b94.jpg";